import React from 'react';
import SapianAIDashboard from './SapianAIDashboard';

function App() {
  return (
    <div className="App">
      <SapianAIDashboard />
    </div>
  );
}

export default App;